module.exports = __webpack_public_path__ + "img/rotate-back.e65a7e57.svg";